import React from "react";
import { HTMLChakraProps, chakra, useStyleConfig } from "@chakra-ui/react";

export interface BlueprintIconProps extends HTMLChakraProps<"svg"> {
  size?: "sm" | "md" | "lg";
}

export const BlueprintIcon: React.FC<BlueprintIconProps> = ({
  size = "md",
  ...rest
}) => {
  const styles = useStyleConfig("BlueprintIcon", { size });

  return <chakra.svg __css={styles} viewBox="0 0 24 24" {...rest} />;
};
